import React from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import "./datePickerTokens.css";

/* Shared calendar grid — token-skinned DayPicker shell for DatePicker / DateRangePicker. */
export function CalendarPanel({
  mode = "single",
  selected,
  onSelect,
  month,
  onMonthChange,
  fromDate,
  toDate,
  disabled,
  disableHighlightToday = false,
  numberOfMonths = 1,
  className,
  ...rest
}) {
  const rootClass = [
    "tk-day-picker",
    disableHighlightToday ? "tk-day-picker--no-today" : "",
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <DayPicker
      mode={mode}
      selected={selected}
      onSelect={onSelect}
      month={month}
      onMonthChange={onMonthChange}
      fromDate={fromDate ?? undefined}
      toDate={toDate ?? undefined}
      disabled={disabled}
      numberOfMonths={numberOfMonths}
      showOutsideDays
      className={rootClass}
      {...rest}
    />
  );
}

export default CalendarPanel;
